import {format, parseISO} from 'date-fns';

export const getDateTimeFromStr = (date: string): string => {
  return format(parseISO(date), 'MMM d, y hh:mm aa');
};
export const getDateFromStr = (date: string): string => {
  return format(parseISO(date), 'MMM d, y');
};
